<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>고객지원</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>불편합니다.</p>
                <!-- <ChevronRight :size="24"></ChevronRight> -->
                <!-- <p>{{ product_models[selectedProduct] }}</p> -->
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">불편합니다.</p>

            <div style="width: 100%; height: 2px; background: black"></div>
        </div>


        <div
            class="row align-space-between screen-width"
            style="margin: 20px 0px"
        >
            <p style="font-size: 28px; font-weight: bold">제목</p>
            <input
                type="text"
                v-model="title"
                style="
                    width: 70%;
                    height: 56px;
                    border: 1px solid #a2a2a2;
                    padding: 12px;
                "
            />
        </div>
        <div class="row align-space-between screen-width"
            style="margin: 40px 0px">
            <p style="font-size: 28px; font-weight: bold">
                        구분
            </p>
            <div class="row align-space-between" style="width: 60%">  
                <div class="row" style="gap: 40px">
                    <input
                                type="radio"
                                v-model="isAgree"
                                :value="1"
                                style="width: 40px"
                    />
                    <p style="font-size: 24px">제품수리</p>
                </div>
                <div class="row" style="gap: 40px">
                    <input
                                type="radio"
                                v-model="isAgree"
                                :value="2"
                                style="width: 40px"
                    />
                    <p style="font-size: 24px">전화상담</p>
                </div>
                <div class="row" style="gap: 40px">
                    <input
                                type="radio"
                                v-model="isAgree"
                                :value="3"
                                style="width: 40px"
                    />
                    <p style="font-size: 24px">설치/판매</p>
                </div>
                <div class="row" style="gap: 40px">
                    <input
                                type="radio"
                                v-model="isAgree"
                                :value="4"
                                style="width: 40px"
                    />
                    <p style="font-size: 24px">기타</p>
                </div>
            </div>
        </div>
        <div class="row align-space-between screen-width" style="height: auto; margin-bottom: 100px">
            <p style="font-size: 28px; font-weight: bold">내용</p>
             <textarea
                v-model="detail"
                style="
                    width: 70%;
                    height: 160px;
                    border: 1px solid #a2a2a2;
                    padding: 12px;
                "
            />
        </div>
        <button
            style="
                width: 320px;
                height: 50px;
                background: #27afe2;
                border-radius: 20px;
                color: white;
                font-size: 32px;
                font-weight: bold;
                margin: 40px;
            "
            @click="submitPraise"
        >
            등록
        </button>
    </v-container>
</template>

<script>
import { ref, onMounted, onUpdated } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Close from "vue-material-design-icons/Close.vue";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
    name: "add-question-answer-layout",
    props: ["id"],
    components: {
        HomeOutline,
        Close,ChevronRight
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        
        const title = ref("");
        const detail = ref("");
        const user_id = ref(null);
        const selectedCategory = ref(4);


        const submitPraise = async () => {
            const praise = {
                userId: user_id.value,
                category: selectedCategory.value,
                title: title.value,
                detail: detail.value,
                type: false
            };
            await store
                .dispatch("addPC", praise)
                .then(() => {
                    alert("글이 등록되었습니다.")
                    router.back();
                })
                .catch((error) => {
                    alert(error);
                });
        };

        onUpdated(() => {});

        onMounted(async () => {
            try {
                const userProfile = await store.dispatch("getUserProfile");
                user_id.value = userProfile.id;
            } catch (err) {
                console.log(err);
            }
        });

        return {
            detail,
            title,
            submitPraise,
            selectedCategory
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

.product-list {
    width: 80%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}

ul {
    list-style-type: none;
    list-style: none;
}

.selected {
    background: #00a7e7 !important;
    color: white;
    font-weight: bold;
}

span {
    height: 20px;
}
</style>
